export default __webpack_public_path__ + "static/media/business_deal.874b762d.svg";